import { FarmView } from './view';
import { FarmsList } from './table';

import { PERMISSION_OBJ_FARM, PERMISSION_OBJ_FARMER_PLOT, PERMISSION_READ } from '@/constants/permissions';

export const states = [
  {
    name: 'base-layout.farms',
    url: '/farms',
    component: FarmsList,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_FARM, PERMISSION_READ]],
    },
  },
  {
    name: 'base-layout.farms.view',
    url: '/:farmId',
    component: FarmView,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_FARM, PERMISSION_READ],
        [PERMISSION_OBJ_FARMER_PLOT, PERMISSION_READ],
      ],
    },
  },
];
